import { defineComponent as _defineComponent } from 'vue'
import ProductTileImageCarousel from '@/ui/shared/product-tile/ProductTileImageCarousel.vue';
import PageService from '@/core/page.service';
import { computed, ref } from 'vue';
import productRegistrationService from '@/services/product-registration.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductRegistrationSearchProductTile',
  props: {
    model: null,
    registerProductDetailsUrl: null
  },
  setup(__props: any) {

const props = __props as {
    model: ProductRegistrationProductTileViewModel,
    registerProductDetailsUrl: string
}



const runImageAnimations = ref<boolean>(false);
const inView = ref<boolean>(false);
const imageReady = ref<boolean>(false);
const isImageErrored = ref<boolean>(false);
const showSpinner = ref<boolean>(false);
const initOverlayAnimations = ref<boolean>(false);
const isEmptyProduct = computed<boolean>(() => !props.model.productId);

const hasImage = computed<boolean>(() => !!props.model.defaultImageUrl);

function setInView() {
    inView.value = true;
    if (!hasImage.value) {
        // Animate the "no-image" if the product does not have an image
        runImageAnimations.value = true;
    }
    delayPreloadSpinner();
};

function imageLoaded() {
    imageReady.value = true;
    isImageErrored.value = false;
    if (inView.value) {
        initAnimations();
    }
}

function imageLoadError() {
    imageReady.value = true;
    isImageErrored.value = true;

    if (inView.value) {
        initAnimations();
    }
}

function initAnimations() {
    runImageAnimations.value = true;
}

function delayPreloadSpinner() {
    setTimeout(() => {
        showSpinner.value = true; // Delay show spinner if images hasn't loaded after 300ms
    }, 300);
}

function selectProduct() {
    productRegistrationService.selectProductAfterSearch(props.model);
    PageService.softRedirect(props.registerProductDetailsUrl);
}

return { __sfc: true,props, runImageAnimations, inView, imageReady, isImageErrored, showSpinner, initOverlayAnimations, isEmptyProduct, hasImage, setInView, imageLoaded, imageLoadError, initAnimations, delayPreloadSpinner, selectProduct, ProductTileImageCarousel }
}

})